import { Field, Form, Formik } from "formik";
import React from "react";
import ButtonComponent from "../../components/generic/ButtonComponent";
import ForceReauthoriseButton from "./ForceReauthoriseButton";
import { useStoreDetails } from "../../hooks/storeHooks";
import "./EbayProvisioningForm.scss";

interface EbayProvisioningFormProps {
  marketplaces: EbayParam[];
  currencies: EbayParam[];
  locales: EbayParam[];
  handleSubmit: Function;
}

const getOptions = (options: EbayParam[]) =>
  options.map((option) => (
    <option key={option.code} value={option.code}>
      {option.description}
    </option>
  ));

const initialValues = {
  marketplace: "EBAY_US",
  currency: "USD",
  locale: "en_US",
};

function EbayProvisioningForm(props: EbayProvisioningFormProps) {
  const { marketplaces, currencies, locales, handleSubmit } = props;
  const { customerName } = useStoreDetails();

  return (
    <div className="ebay-provisioning-form">
      <div className="ebay-provisioning-form__header">
        <h3>Provisioning Settings</h3>
        <ForceReauthoriseButton integration="ebay" />
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={(values, { setSubmitting }) =>
          handleSubmit(customerName, values, setSubmitting)
        }
      >
        {({ isSubmitting }) => (
          <Form>
            <div className="ebay-provisioning-form__inputs">
              <label id="marketplace">Marketplace</label>
              <Field
                as="select"
                name="marketplace"
                aria-labelledby="marketplace"
              >
                {getOptions(marketplaces)}
              </Field>
              <label id="currency">Currency</label>
              <Field as="select" name="currency" aria-labelledby="currency">
                {getOptions(currencies)}
              </Field>
              <label id="locale">Locale</label>
              <Field as="select" name="locale" aria-labelledby="locale">
                {getOptions(locales)}
              </Field>
            </div>
            <div className="ebay-provisioning-form__actions">
              <ButtonComponent primary type="submit" disabled={isSubmitting}>
                Save and continue
              </ButtonComponent>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default EbayProvisioningForm;
